"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _External = require("../External");

var _queryString = _interopRequireDefault(require("query-string"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var availableLocales = ['de', 'at', 'pl'];

function createRouter(base, internalLocalizedRoutes, externalRoutes, externalStaticRoutes) {
  var internalDefaultRoutes = Object.keys(internalLocalizedRoutes).reduce(function (result, key) {
    var route = internalLocalizedRoutes[key];

    if (typeof route === 'string') {
      result[key] = route;
    } else {
      result[key] = route.de;
    }

    return result;
  }, {});

  var isSupportedLocale = function isSupportedLocale(availableLocales, locale) {
    return availableLocales.includes(locale);
  };

  var RouteContext = /*#__PURE__*/_react.default.createContext({
    internal: internalDefaultRoutes,
    external: {},
    externalStatic: {}
  });

  var RouteActionsContext = /*#__PURE__*/_react.default.createContext({
    routeInternal: function routeInternal() {},
    routeExternal: function routeExternal() {},
    routeExternalStatic: function routeExternalStatic() {},
    getInternalRoute: function getInternalRoute() {
      return {};
    }
  });

  var RouteProvider = function RouteProvider(_ref) {
    var children = _ref.children;
    var applicationRoutes = (0, _react.useContext)(_External.RouteContext);
    var navigate = (0, _reactRouterDom.useNavigate)();
    var locale;

    if (typeof applicationRoutes._locale === 'undefined') {
      locale = 'de';
    } else if (!isSupportedLocale(availableLocales, applicationRoutes._locale)) {
      throw Error("Locale \"".concat(applicationRoutes._locale, "\" not supported by this application"));
    } else {
      locale = applicationRoutes._locale;
    }

    var externalStatic = externalStaticRoutes.reduce(function (result, key) {
      result[key] = applicationRoutes[key];
      return result;
    }, {});
    var external = externalRoutes.reduce(function (result, key) {
      result[key] = applicationRoutes[key];
      return result;
    }, {});
    var internalRoutes = Object.keys(internalLocalizedRoutes).reduce(function (result, key) {
      var route = internalLocalizedRoutes[key];

      if (typeof route === 'string') {
        result[key] = route;
      } else {
        result[key] = route[locale];
      }

      return result;
    }, {});
    var getInternalRoute = (0, _react.useCallback)(function (key, params, query, state) {
      var newRoute;
      var selectedRoute = internalRoutes[key].replace(/\/\*$/, '/');

      if (params) {
        newRoute = {
          pathname: Object.keys(params).reduce(function (route, param) {
            return route.replace(new RegExp(":".concat(param, "/")), "".concat(params[param], "/"));
          }, external[base] + selectedRoute)
        };
      } else {
        newRoute = {
          pathname: external[base] + selectedRoute
        };
      }

      if (query) {
        newRoute.search = _queryString.default.stringify(query);
      }

      if (state) {
        newRoute.state = state;
      }

      return newRoute;
    }, [internalRoutes, external]);
    var routeInternal = (0, _react.useCallback)(function (key, params, query, state) {
      navigate(getInternalRoute(key, params, query, state));
    }, [navigate, getInternalRoute]);
    var routeExternal = (0, _react.useCallback)(function (key) {
      var target = external[key];

      if (typeof target === 'undefined') {
        throw Error("External routes do not define \"".concat(key, "\"!"));
      } else if (target) {
        navigate(target);
      }
    }, [navigate, external]);
    var routeExternalStatic = (0, _react.useCallback)(function (key) {
      var target = externalStatic[key];

      if (typeof target === 'undefined') {
        throw Error("External static routes do not define \"".concat(key, "\"!"));
      } else if (target && typeof window !== 'undefined') {
        window.location.href = target;
      }
    }, [externalStatic]);
    var actions = (0, _react.useMemo)(function () {
      return {
        routeInternal: routeInternal,
        routeExternal: routeExternal,
        routeExternalStatic: routeExternalStatic,
        getInternalRoute: getInternalRoute
      };
    }, [routeInternal, routeExternal, routeExternalStatic, getInternalRoute]);
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(RouteActionsContext.Provider, {
      value: actions,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(RouteContext.Provider, {
        value: {
          external: external,
          internal: internalRoutes,
          externalStatic: externalStatic
        },
        children: children
      })
    });
  };

  return {
    context: RouteContext,
    actions: RouteActionsContext,
    provider: RouteProvider
  };
}

var _default = createRouter;
exports.default = _default;